import type { Logger, LogLevel, Data } from './index.ts';

export abstract class BaseLogger implements Logger {
  log(message: unknown, data?: Data) {
    this.exec('log', message, data);
  }

  info(message: unknown, data?: Data) {
    this.exec('info', message, data);
  }

  warn(message: unknown, data?: Data) {
    this.exec('warn', message, data);
  }

  error(message: unknown, data?: Data) {
    this.exec('error', message, data);
  }

  protected abstract exec(level: LogLevel, message: unknown, data?: Data): void;
}
